module.exports = __webpack_public_path__ + "static/media/60s.5df59456.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/60s.png
// module id = 639
// module chunks = 0 1